export default __webpack_public_path__ + "static/media/investors_logo10.8faf5034.png";